export default {
      id: "post-usage",
      viewBox: "0 0 103 76",
      url: "../dist/images/" + "sprite.svg#post-usage",
      toString: function () {
        return this.url;
      }
    }